import React, { PropsWithChildren, useContext } from 'react';

import { ServerDataContext } from './ServerDataContext';


export const AcornContext = React.createContext<boolean>(false);

export const AcornProvider: React.FunctionComponent<PropsWithChildren> = ({ children }) => {
  const data = useContext(ServerDataContext);

  return (
    <AcornContext.Provider value={ data.isAcornEnabled }>
      { children }
    </AcornContext.Provider>
  );
};